const PHRASES = [
  "LÁMPARAS COLGANTES EDICIÓN LIMITADA",
  "LUMEN & ESCULTURA",
  "NORDIC MINIMALISM 2026",
  "LATÓN CEPILLADO Y VIDRIO SOPLADO",
  "ILUMINACIÓN ARQUITECTÓNICA HYLASU",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-stone-200/80 bg-[#F4F0EA] py-4 dark:border-stone-800 dark:bg-[#141210]"
  >
    <div className="animate-marquee flex w-max items-center">
      {[...PHRASES, ...PHRASES].map((p, i) => (
        <span
          key={i}
          className="flex items-center whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.3em] text-stone-500 dark:text-stone-400"
        >
          <span className="px-8">{p}</span>
          <span className="text-amber-600 dark:text-amber-400">✦</span>
        </span>
      ))}
    </div>
  </div>
);
